import styled, { css } from 'styled-components/macro'

const StatusColorCSS = (status: 'success' | 'fail' | 'pending') => {
  if (status === 'success')
    return css`
      color: #44c8a6;
      font-weight: bold;
    `
  if (status === 'fail')
    return css`
      color: #ff0100;
      font-weight: bold;
    `
  return css`
    color: #fdb44b;
    font-weight: bold;
  `
}

export const StatusColor = styled.div<{ status: 'success' | 'fail' | 'pending' }>`
  ${(props) => StatusColorCSS(props.status)}
`

export const TokenTransferredValue = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

const EllipsisTextCSS = (isAddress?: boolean) => {
  if (isAddress)
    return css`
      color: #0097fe;
      cursor: pointer;

      &:hover {
        color: #003893;
      }
    `
  return css``
}

export const EllipsisText = styled.button<{ isAddress?: boolean }>`
  width: 90px;
  background-color: transparent;
  border: none;
  font-weight: 400;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: initial;
  ${(props) => EllipsisTextCSS(props.isAddress)}
`

export const TokenTicker = styled.img`
  width: 15px;
  height: 15px;
  border-radius: 50%;
`
